module.exports = __webpack_public_path__ + "img/vertical_7_2_5012.391939c4.png";